/**
 * Written by Windsurf using model: Claude Sonnet 4.5 (Thinking)
 */
import { Box, InputAdornment, TextField } from '@mui/material'

interface ScenarioInputFieldsProps {
  readonly proposedRate: number | null
  readonly wamYears: number | null
  readonly onProposedRateChange: (
    e: React.ChangeEvent<HTMLInputElement>
  ) => void
  readonly onWamYearsChange: (e: React.ChangeEvent<HTMLInputElement>) => void
}

export default function ScenarioInputFields({
  proposedRate,
  wamYears,
  onProposedRateChange,
  onWamYearsChange,
}: Readonly<ScenarioInputFieldsProps>) {
  return (
    <Box
      sx={{
        display: 'flex',
        gap: 2,
        mb: 3,
        width: '100%',
      }}
    >
      <TextField
        label="Proposed Rate"
        type="number"
        value={proposedRate === null ? '' : proposedRate}
        onChange={onProposedRateChange}
        size="small"
        fullWidth
        error={false}
        helperText="Enter proposed rate"
        slotProps={{
          htmlInput: {
            step: '0.01',
            min: 0,
          },
          input: {
            endAdornment: <InputAdornment position="end">%</InputAdornment>,
          },
        }}
      />
      <TextField
        label="WAM"
        type="number"
        value={wamYears === null ? '' : wamYears}
        onChange={onWamYearsChange}
        size="small"
        fullWidth
        error={false}
        helperText="Enter weighted average maturity"
        slotProps={{
          htmlInput: {
            step: '0.1',
            min: 0,
          },
          input: {
            endAdornment: <InputAdornment position="end">years</InputAdornment>,
          },
        }}
      />
    </Box>
  )
}
